import { type Editor, type Extensions } from "@tiptap/react";
import { cx } from "shared/utils";
import type { EditorProps } from "./core/types/editor";
import { useEditor } from "./core/hooks/use-editor";
import { EditorContentWrapper } from "./editor-content";
import { EditorContainer } from "./editor-container";

type EditorWrapperProps = EditorProps & {
  children?: (editor: Editor) => React.ReactNode;
  editable: boolean;
  extensions: Extensions;
};

export const EditorWrapper = (props: EditorWrapperProps) => {
  const {
    children,
    containerClassName,
    editable,
    editorClassName = "",
    editorProps,
    extensions,
    forwardedRef,
    id,
    initialValue,
    isTouchDevice,
    mentionHandler,
    onChange,
    onEditorFocus,
    onTransaction,
    handleEditorReady,
    autofocus,
    tabIndex,
    placeholder,
    value
  } = props;

  const editor = useEditor({
    editable,
    editorClassName,
    editorProps,
    extensions,
    forwardedRef,
    isTouchDevice,
    initialValue,
    mentionHandler,
    onChange,
    onEditorFocus,
    onTransaction,
    handleEditorReady,
    autofocus,
    placeholder,
    value,
    id
  });

  if (!editor) return null;

  return (
    <EditorContainer
      editor={editor}
      editorContainerClassName={cx("w-full max-w-full", containerClassName)}
      id={id}
      isTouchDevice={Boolean(isTouchDevice)}
    >
      {children?.(editor)}
      <div className="flex flex-col">
        <EditorContentWrapper editor={editor} id={id} tabIndex={tabIndex} />
      </div>
    </EditorContainer>
  );
};
